import * as React from "react";
export var FontWithOutline = function (_a) {
    var style = _a.style, children = _a.children, customRef = _a.customRef;
    return (React.createElement("div", { className: "font-with-outline " + style + "Outline", ref: customRef },
        children,
        React.createElement("span", { className: "" + style }, children)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/font-with-outline/FontWithOutline.tsx
// module id = 77
// module chunks = 3